import AxiosService from './AxiosService'

class SsoProxyRestService {
  static getConfigurationStatus(): Promise<any> {
    return AxiosService.get('/SSOProxy/getConfigurationStatus')
  }

  static getGatewayIssuerConfiguration(): Promise<any> {
    return AxiosService.get('/SSOProxy/getGatewayIssuerConfiguration')
  }

  static getSupportedSignatureAlgorithms(): Promise<any> {
    return AxiosService.get('/SSOProxy/getSupportedSignatureAlgorithms')
  }

  static setGatewayIssuerConfiguration(config: any): Promise<any> {
    return AxiosService.post('/SSOProxy/setGatewayIssuerConfiguration', config)
  }

  static getGatewayCertificates(): Promise<any> {
    return AxiosService.get('/SSOProxy/getGatewayCertificates')
  }

  static generateGatewayCertificates(): Promise<any> {
    return AxiosService.post('/SSOProxy/generateGatewayCertificates')
  }

  static getRewritingRules(): Promise<any> {
    return AxiosService.get('/SSOProxy/rewritingRules')
  }

  static createRewritingRules(rule: any): Promise<any> {
    return AxiosService.post('/SSOProxy/rewritingRules/create', rule)
  }

  static updateRewritingRules(rule: any): Promise<any> {
    return AxiosService.post('/SSOProxy/rewritingRules/update', rule)
  }

  static deleteRewritingRules(id: any): Promise<any> {
    return AxiosService.delete('/SSOProxy/rewritingRules/delete/' + id)
  }

  static getTargetIdPInfo(): Promise<any> {
    return AxiosService.get('/SSOProxy/getTargetIdPInfo')
  }

  static uploadIdPMetadata(idPMetadata: any): Promise<any> {
    return AxiosService.post('/SSOProxy/uploadIdPMetadata', idPMetadata)
  }

  static downloadGatewayIdPMetadata(): Promise<any> {
    return AxiosService.get('/SSOProxy/downloadGatewayIdPMetadata', { responseType: 'blob' })
  }

  static getTargetSPInfo(): Promise<any> {
    return AxiosService.get('/SSOProxy/getTargetSPInfo')
  }

  static uploadSPMetadata(spMetadata: any): Promise<any> {
    return AxiosService.post('/SSOProxy/uploadSPMetadata', spMetadata)
  }

  static downloadGatewaySPMetadata(): Promise<any> {
    return AxiosService.get('/SSOProxy/downloadGatewaySPMetadata', { responseType: 'blob' })
  }
}

export default SsoProxyRestService
